// src/core/stores/ownerStore.ts — client-side prototype state for owner infra actions.
// Real user/content/audit state is now server-backed (ownerService / useOwnerAudit).
// This store retains ONLY the still-prototype infra surface:
//   - announcements list
//   - logAction() used ONLY by Dashboard Quick Actions (announcement/maintenance/clear-cache/backups/export)
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AuditEntry } from '@/core/models/owner';

const KEY = 'truxsocial:owner';
let seq = 0;
const makeId = () => `audit-${Date.now()}-${seq++}`;

interface OwnerState {
  announcements: Array<{ id: string; text: string; at: string }>;
  auditEntries: AuditEntry[];
  logAction: (e: Omit<AuditEntry, 'id' | 'timestamp'>) => void;
  reset: () => void;
}

export const useOwnerStore = create<OwnerState>()(
  persist(
    (set) => ({
      announcements: [],
      auditEntries: [],
      logAction: (e) =>
        set((s) => ({
          auditEntries: [{ ...e, id: makeId(), timestamp: new Date().toISOString() }, ...s.auditEntries],
        })),
      reset: () => {
        localStorage.removeItem(KEY);
        set({ announcements: [], auditEntries: [] });
      },
    }),
    {
      name: KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        announcements: s.announcements,
        auditEntries: s.auditEntries,
      }),
    },
  ),
);
